import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

// Envoie l'URL de la photo de profil à l'app iOS, qui la pose (ronde) comme icône
// de l'onglet « Mon profil » de la tab bar — comme la bottom bar du web.
// Voir TabAvatarComponent côté natif.
//
// Placé sur le <body> du layout quand hotwire_native_app? && user_signed_in?
// (via body_bridge_attributes).
export default class extends BridgeComponent {
  static component = 'tab-avatar'
  static values = { url: String }

  connect() {
    super.connect()
    this.send('connect', { url: this.urlValue })
  }
}
